<template>
  <div class="ccontainer">
    <div class="prejoin-preview-dropdown-container">
      <div class="css-1hbmoh1-actionButton primary-inverted" role="button" tabindex="0">
        <div v-if="videoCallRoom.is_unlimited">
          <span class="css-1hbmoh1-actionButton-label">{{ $t("videocall.label.unlimited") }}</span>
        </div>
        <countdown
          v-else
          :time="timeLeft"
          @progress="handleCountdownProgress"
        >
          <template slot-scope="props">{{ parseTime(props) }}</template>
        </countdown>
      </div>
    </div>
  </div>
</template>

<script>
const WarnAudio = new Audio("/audio/piano.mp3");

export default {
  props: {
    videoCallRoom: {
      required: true,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    handleCountdownProgress(e) {
      const secondsLeft = e.totalSeconds;
      this.$emit("remainingTime", secondsLeft);

      if (secondsLeft == 30) WarnAudio.play();
      if (secondsLeft == 1 && !this.hardcodeTimeLeft) this.$emit("end");
    },
    parseTime(props) {
      if (this.hardcodeTimeLeft) return "99:99";

      const minutes = props.minutes + props.hours * 60;
      const seconds = props.seconds < 10 ? "0" + props.seconds : props.seconds;

      return `${minutes}:${seconds}`;
    },
  },
  computed: {
    hardcodeTimeLeft() {
      return !(this.videoCallRoom.started_at && !this.videoCallRoom.is_unlimited);
    },
    timeLeft() {
      const totMinutes =
        this.videoCallRoom.mins + this.videoCallRoom.extra_minutes_bought;

      const endTimestamp =
        this.videoCallRoom.started_at + totMinutes * 60 * 1000;

      const reimaingTime = endTimestamp - Date.now();

      return (reimaingTime < 0 || !reimaingTime) ? 10 * 1000 : reimaingTime;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./jisti.scss";

.css-1hbmoh1-actionButton.primary-inverted {
  background-color: transparent;
  border: 1px solid rgb(36, 111, 229);

  -webkit-user-select: none;
  user-select: none;
  cursor: default;

  &:hover {
    background-color: transparent;
    cursor: default;
  }
}
</style>
